var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-active":_vm.$route.path,"background-color":_vm.variables.menuBg,"text-color":_vm.variables.menuText,"active-text-color":_vm.variables.menuActiveText,"mode":"horizontal"}},_vm._l((_vm.permission_routers),function(route){return _c('menubar-item',{key:route.path,attrs:{"item":route,"base-path":route.path}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }